import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  "aria-hidden": "true",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.75 3.75c0 .269-.057.572-.157.894-.178.575-.487 1.212-.856 1.85l-.003.006q-.145.251-.3.5-.207.329-.422.65l-.013.018A31 31 0 0 1 9.462 9.75c-.24.3-.687.3-.925 0A32 32 0 0 1 7 7.668c-.575-.853-1.135-1.796-1.46-2.637q-.038-.099-.072-.197c-.137-.394-.218-.762-.218-1.081q.001-.22.025-.431a3.749 3.749 0 0 1 7.475.428M11 10.393c.421-.568.9-1.247 1.334-1.95q.085-.134.165-.275v7.01l4-1.454V5.822l-3.397 1.234c.07-.147.138-.29.197-.438.185-.437.344-.912.413-1.38l3.28-1.194A.748.748 0 0 1 18 4.75v9.5a.75.75 0 0 1-.494.706l-5.5 2a.76.76 0 0 1-.512 0l-5.243-1.91-5.244 1.906A.748.748 0 0 1 0 16.25v-9.5c0-.315.197-.596.494-.705L4.25 4.678v.072c0 .472.115.96.278 1.425L1.5 7.275v7.902l4-1.453V8.172l.165.275c.435.703.91 1.38 1.335 1.95v3.33l4 1.454zM9 4.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" }, null, -1)
  ])))
}
export default { render: render }